<template lang="pug">
  .v-payments(:class='loadingClass')
    label.v-payment.form__radio(
      :class="{selected: isStripeSelected}",
      v-if="isAvailablePaymentMethod('stripe')"
    )
      .u-flex.u-flex-ai-center(style="min-height: 30px;")
        input.form-ctl(type="radio", name="payment_id", value="stripe", v-model="selectedPaymentId")
        span.label
        div Credit Card
      .v-cards.u-mlm.u-mtxs
        template(v-for="card in filteredListByStripe")
          label.v-card.form__radio.u-flex.u-flex-ai-center(
            :class="{selected: selectedCardPaymentId === card._id}"
          )
            input.form-ctl(type="radio", name="card_id", :value="card._id", v-model="selectedCardPaymentId")
            span.label
            .u-mrs
              img(
              :src="getPaymentMethodImagePath(card).src | cloudImageUrl",
              :alt="getPaymentMethodLabel(card)"
              height="30"
              )
            .v-card__info
              .u-mrs
                span.v-card__info-label Ending in
                span.v-card__info-value(v-text="card.stripe.card.last4")
              .u-mrs
                span.v-card__info-label Expires
                span.v-card__info-value(v-text="card.stripe.card.exp_month + '/' + card.stripe.card.exp_year")
            .v-card__action
              button.c-btn.c-btn--link.c-btn--sm(type="button", @click.prevent='onEditCard(card._id)') Edit
              button.c-btn.c-btn--link.c-btn--sm(type="button", @click.prevent='onDeletePayment(card._id)') Delete
          .v-form(v-if="selectedCardPaymentId === card._id && editingCardPaymentId === card._id")
            vue-payments-manage-input(
              :payment-id="card._id",
              :service="service",
              :recaptcha-site-key="recaptchaSiteKey",
              :stripe-key="stripeKey",
              @added="onCardAdded",
              @updated="onCardChanged",
              @auth-error="onAuthError"
            )

        // 新規にクレジットカードを登録
        label.v-card.form__radio.u-block(:class="{selected: willAddNewCreditCard}")
          .u-flex.u-flex-ai-center(style="min-height: 30px;")
            input.form-ctl(type="radio", name="card_id", value="new", v-model="selectedCardPaymentId")
            span.label
            div Add a New Card
        .v-form(v-if="willAddNewCreditCard")
          vue-payments-manage-input(
            payment-id="new",
            :service="service",
            :recaptcha-site-key="recaptchaSiteKey",
            :stripe-key="stripeKey",
            @added="onCardAdded",
            @updated="onCardChanged",
            @auth-error="onAuthError"
          )

    label.v-payment.form__radio.form__radio--btn(
      v-for="payment in filteredListOtherThenStripe",
      :class="{selected: selectedPaymentId === payment._id}"
    )
      .u-flex.u-flex-ai-center
        input.form-ctl(
          type='radio',
          name='payment',
          :value='payment._id',
          v-model='selectedPaymentId',
          @change.prevent='onSelectPayment'
        )
        span.label
        span.u-mrs(v-if="payment.method !== PAYMENT_METHOD.CONVENIENCE_STORE")
          img(
            :src='getPaymentMethodImagePath(payment).src | cloudImageUrl',
            :alt='getPaymentMethodImagePath(payment).alt',
            width='34'
          )
        span(v-text='getPaymentMethodLabel(payment)')
        template(v-if="payment.method === 'paypal' && $store.state.user.lang === 'ja'")
          span.u-mlxs
            img(:src="conf.path.resize_origin + 'static/common/icons/paypal_mizuho.png'", alt="みずほ銀行", height="24")
          span.u-mlxs
            img(:src="conf.path.resize_origin + 'static/common/icons/paypal_smbc.png'", alt="三井住友銀行", height="24")
          span.u-mlxs
            img(:src="conf.path.resize_origin + 'static/common/icons/paypal_yucho.png'", alt="ゆうちょ銀行", height="24")
          span.u-mlxs
            img(:src="conf.path.resize_origin + 'static/common/icons/paypal_risona.png'", alt="りそな銀行", height="24")
          span.u-mlxs
            img(:src="conf.path.resize_origin + 'static/common/icons/paypal_risona-saitama.png'", alt="埼玉りそな銀行", height="24")

        span.u-mlxs(v-if='payment.method === PAYMENT_METHOD.CONVENIENCE_STORE')
          span.u-fs-sm.u-weight-normal(v-if='$parent.selectedConveniCode')
            img(:src='$store.getters["convenienceStores/getImagePath"]($parent.selectedConveniCode).src | cloudImageUrl', alt='', style="height: 16px;")
            span.u-mlxs(v-text='__($store.getters["convenienceStores/findById"]($parent.selectedConveniCode).name)')
          span.u-mlxs.u-fs-sm.u-weight-normal
            a.u-mlxs(href='#', @click.prevent='select(payment._id)', v-text='__("Choose a CS")')

    .v-payment__action
      button.c-btn.c-btn--primary.c-btn--round.c-btn--lg(
        :disabled="!isValid",
        v-text="buttonLabel",
        @click="select"
      )

    slot(name='footer')
</template>

<script>
import includes from 'latest_modules/lodash/includes';

import { Payment } from '../../stores/schema/Payment';
import { PAYMENT_METHOD, PAYMENT_METHOD_PATTERN } from '../../constants/shop';
import { SERVICES, SERVICES_PATTERN } from '../../constants/service';
import { default as urlUtil } from '../../util/url';
import { I18n } from '../../util/mixin/i18n.mixin';

import PaymentsManageInput from './PaymentsManageInput.vue';

export default {
  mixins: [I18n],
  components: {
    'vue-payments-manage-input': PaymentsManageInput
  },
  data() {
    return {
      loading: false,
      selectedPaymentId: null,
      selectedCardPaymentId: null,
      editingCardPaymentId: null
    };
  },

  props: {
    // 使用するサービス名
    // 'shop' or 'subscription' default: ''
    // サービス名を指定すると自動的にそのサービスで使用するデフォルトの住所に変更されます
    // 住所変更などデフォルトを変更せず参照のみを行う場合は、 service を指定しないこと
    service: {
      type: String,
      default: 'shop'
    },

    // 利用できない決済方法
    // 複数の場合はカンマ区切りで指定
    // ex) unavailable-payment-methods="paypal,amazon"
    unavailablePaymentMethods: {
      type: String,
      default: ''
    },

    stripeKey: {
      type: String
    },
    recaptchaSiteKey: {
      type: String
    },
    ignoreCurrent: {
      type: Boolean,
      default: false
    },
    buttonLabel: {
      type: String,
      default: 'Select Payment Method'
    }
  },

  computed: {
    loadingClass() {
      return {
        loading: this.loading,
        'loading--opacity': this.loading
      };
    },

    payments() {
      return this.$store.getters['payments/list'];
    },

    findPaymentById() {
      return this.$store.getters['payments/findById'];
    },

    current() {
      return this.$store.getters['payments/current'];
    },

    getPaymentMethodImagePath() {
      return (payment) =>
        this.$store.getters['payments/getPaymentMethodImagePath'](payment);
    },

    getPaymentMethodLabel() {
      return (payment) =>
        this.$store.getters['payments/getPaymentMethodLabel'](payment);
    },

    filteredListByStripe() {
      const payments = this.$store.getters['payments/find']((payment) => {
        return Payment.isStripe(payment);
      });
      return payments.map((payment) => {
        payment.stripe.card = this.$store.getters['payments/findCardById'](
          payment.stripe.card_id
        );
        return payment;
      });
    },

    filteredListOtherThenStripe() {
      return this.$store.getters['payments/find']((payment) => {
        return (
          !Payment.isStripe(payment) &&
          this.isAvailablePaymentMethod(payment.method)
        );
      });
    },

    isStripeSelected() {
      return this.selectedPaymentId === 'stripe';
    },

    willAddNewCreditCard() {
      return this.isStripeSelected && this.selectedCardPaymentId === 'new';
    },

    conf() {
      return window.tom.conf;
    },

    PAYMENT_METHOD() {
      return PAYMENT_METHOD;
    },
    SERVICES() {
      return SERVICES;
    },

    isValid() {
      let valid = !!this.selectedPaymentId;

      // クレジットカードを選択している場合
      if (this.isStripeSelected) {
        valid =
          !this.willAddNewCreditCard &&
          !this.editingCardPaymentId &&
          !!this.selectedCardPaymentId;
      }

      return valid;
    }
  },

  watch: {
    selectedCardPaymentId() {
      this.editingCardPaymentId = null;
    },
    current(val) {
      if (
        this.ignoreCurrent ||
        this.editingCardPaymentId ||
        this.willAddNewCreditCard
      ) {
        return;
      }
      if (val) {
        this.selectedPaymentId = val._id;

        if (Payment.isStripe(val)) {
          this.selectedPaymentId = 'stripe';
          this.selectedCardPaymentId = val._id;
        }
      } else {
        this.selectedPaymentId = 'stripe';
        this.selectedCardPaymentId = 'new';
      }
    }
  },

  filters: {
    cloudImageUrl: urlUtil.cloudImageUrl,
    resizedImageUrl: urlUtil.resizedImageUrl,
    webp: urlUtil.webp
  },

  created() {
    if (this.service && includes(SERVICES_PATTERN, this.service)) {
      this.$store.dispatch('payments/setService', this.service);
    }
  },

  mounted() {
    this.fetch().then(() => {
      // 使用する決済情報が設定されておらず、クレジットカードも登録されていない場合は
      // 新規クレジットカードをデフォルト選択させる
      if (!this.current && !this.filteredListByStripe.length) {
        this.selectedPaymentId = 'stripe';
        this.selectedCardPaymentId = 'new';
      }
    });
  },

  methods: {
    isAvailablePaymentMethod(method) {
      if (!includes(PAYMENT_METHOD_PATTERN, method)) {
        return false;
      }
      return !includes(this.unavailablePaymentMethods.split(','), method);
    },

    /*
    User action
    */
    // Payment method を選択した
    onSelectPayment() {
      // this.select(this.selectedId);
    },

    // Payment method を削除しようとした
    onDeletePayment(id) {
      this.$confirm('Are you sure you want to delete this payment method ?')
        .then(() => {
          this.delete(id);
        })
        .catch(() => {});
    },

    // Credit card 情報を編集しようとした
    onEditCard(id) {
      if (this.editingCardPaymentId === id) {
        this.editingCardPaymentId = null;
        return;
      }
      this.editingCardPaymentId = id;
    },

    // Credit card 情報が追加された
    onCardAdded(res) {
      this.selectedPaymentId = 'stripe';
      this.selectedCardPaymentId = res._id;
      this.editingCardPaymentId = null;
    },

    // Credit card 情報が更新された
    onCardChanged() {
      this.selectedCardPaymentId = this.editingCardPaymentId;
      this.editingCardPaymentId = null;
    },

    onAuthError(err) {
      this.$emit('auth-error', err);
    },

    /*
    Action
    */
    // 登録している Payment methods を取得する
    fetch() {
      this.loading = true;
      return this.$store
        .dispatch('payments/fetchAll')
        .then(() => {
          this.$emit('load');
        })
        .catch((err) => {
          if (err && err.response && err.response.status === 401) {
            this.onAuthError();
          } else {
            this.$alert(
              err.general ||
                'An error occurred. Please wait a moment before trying again.'
            );

            this.$emit('error', err);
          }
        })
        .then(() => {
          this.loading = false;
        });
    },

    // 配送する Payment method のデフォルトを変更する
    select() {
      const id =
        this.selectedPaymentId === 'stripe'
          ? this.selectedCardPaymentId
          : this.selectedPaymentId;

      if (this.ignoreCurrent) {
        return this.$emit('change', this.findPaymentById(id));
      }
      this.loading = true;
      return Promise.resolve()
        .then(() => {
          if (this.service) {
            return this.$store.dispatch('payments/changeCurrent', { _id: id });
          } else {
            return Promise.resolve();
          }
        })
        .then(() => {
          this.$emit('change', this.findPaymentById(id));
        })
        .catch((err) => alert(err.general || err))
        .then(() => {
          this.loading = false;
        });
    },

    // Payment methods を削除する
    // @param {String} id Payment ID
    delete(id) {
      this.loading = true;
      this.$store
        .dispatch('payments/remove', { _id: id })
        .then(() => {
          if (!this.current) {
            this.selectedPaymentId = 'stripe';
            if (this.filteredListByStripe[0]) {
              this.selectedCardPaymentId = this.filteredListByStripe[0]._id;
            } else {
              this.selectedCardPaymentId = 'new';
            }
          }
        })
        .catch((err) => {
          if (err.type === 'no_payment') {
            window.location.reload();
            return;
          }
          alert(err.general || err);
        })
        .then(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
.v-payment {
  display: block;
  border-bottom: 1px solid #cccccc;
  font-weight: normal;
  margin-bottom: 0;
  padding: 10px;
}

.v-cards {
  display: none;
}

.v-card {
  font-weight: normal;
  margin-bottom: 0;
  padding: 10px;
}

.v-card__info {
  display: flex;
  flex: 1;
}

.v-card__info-label {
  display: block;
  font-size: 12px;
  font-weight: normal;
  line-height: 1;
}

.v-card__info-value {
  display: block;
  font-weight: bold;
}

.v-card__action {
  display: none;
}

.v-payment.selected {
  background: #d5e9f4;
}

.v-payment.selected .v-cards {
  display: block;
}

.v-payment.selected .v-cards .v-card.selected {
  background: #95cbe8;
}

.v-payment.selected .v-cards .v-card.selected .v-card__action {
  display: block;
}

.v-form {
  background: white;
  padding: 20px;
}

.v-payment__action {
  display: flex;
  padding: 10px;
  justify-content: center;
}
</style>
